export enum Orientation {
    Horiztonal = 'horizontal',
    Vertical = 'vertical'
}
